import { Box, SxProps, Theme, Typography } from '@mui/material';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { TranscoderProfile, TranscoderTemplate } from '@vxui/common';

const defaultProfilesContainerStyle = {
  width: '220px',
  padding: '5px 0px',
  marginRight: '30px',
  marginBottom: '15px',
};

const textMarginBottomStyle = {
  marginBottom: '7px',
};

type ExpandGridTemplateProps = {
  name: string;
};

const ExpandGridTemplate = ({ name }: ExpandGridTemplateProps): ReactElement => {
  return (
    <Typography sx={textMarginBottomStyle} variant="p16">
      {name}
    </Typography>
  );
};

type ExpandGridTemplatesProps = {
  templates?: TranscoderTemplate[];
  title: string;
  sx?: SxProps<Theme>;
};

const ExpandGridTemplates = ({ sx, templates, title }: ExpandGridTemplatesProps): ReactElement => {
  const components: ReactElement[] = [];

  if (templates) {
    for (const template of templates) {
      components.push(<ExpandGridTemplate key={template.id} name={template.name} />);
    }
  }

  return (
    <Box sx={{ ...defaultProfilesContainerStyle, ...sx }}>
      <Typography sx={textMarginBottomStyle} variant="p16Bold">
        {title}
      </Typography>
      {components}
    </Box>
  );
};

const ExpandGrid = ({ profile }: ExpandProfileProps): ReactElement => {
  const { t } = useTranslation();
  return (
    <Box display="flex">
      <ExpandGridTemplates
        sx={{ marginLeft: '48px' }}
        templates={profile.templates}
        title={`${t('navigation.template.index')} (${profile.templates?.length})`}
      />
    </Box>
  );
};

type ExpandProfileProps = {
  profile: TranscoderProfile;
};

export const ExpandProfile = ({ profile }: ExpandProfileProps): ReactElement => {
  return (
    <Box>
      <ExpandGrid profile={profile} />
    </Box>
  );
};
